import type { ReactNode } from "react";
import { useSession } from "../session/SessionProvider";
import type { ModulePermission, PermissionModule } from "../session/types";

interface CanProps {
  module: PermissionModule;
  action?: keyof Omit<ModulePermission, "module">;
  children: ReactNode;
}

/**
 * Gate de UI por permiso efectivo. IMPORTANTE (web/AGENTS.md, SPEC-201 §2 y
 * §4.1): esto solo decide si algo se MUESTRA. No es control de acceso — el
 * servidor tiene que rechazar la misma acción de forma independiente. Un
 * `<Can>` sin el 403 correspondiente en el endpoint es un finding `fail`
 * dirigido a api-http, no un bug de este componente.
 *
 * Acción sin permiso: no se renderiza. Nunca deshabilitada (SPEC-201 §4.1:
 * "un botón gris invita a preguntar por qué").
 */
export function Can({ module, action = "canView", children }: CanProps) {
  const { hasPermission } = useSession();
  if (!hasPermission(module, action)) return null;
  return <>{children}</>;
}
